import { gql } from '@apollo/client';

export const CREATE_MERCHANT = gql`
  mutation company($input: CompanyInput) {
    createMerchant(input: $input) {
      id
    }
  }
`;
